import type ResultStore from 'src/internal/revamp/observable/ResultStore';
import type {
  GraphQlDocument,
  VariablesOfDoc,
} from 'src/internal/shared/graphql/types/document';

export default class InteroperabilityLayer {
  private resultStore: ResultStore;

  constructor(resultStore: ResultStore) {
    this.resultStore = resultStore;
  }

  public refreshQueryStaleness<
    TDocumentNode extends GraphQlDocument<any, any, any, any>,
  >(
    query: TDocumentNode,
    variables: VariablesOfDoc<TDocumentNode> | undefined,
  ): void {
    this.resultStore.refreshStaleness(query, variables);
  }
}
